import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import {
  BadgeOutlined,
  CategoryOutlined,
  DomainOutlined,
  EmailOutlined,
  InfoOutlined,
  Phone,
} from "@mui/icons-material";

import { useAccountDetailContext } from "contexts/AccountDetailContext";

import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";

import Status from "components/Shared/Status";

const AccountBasicDetail = () => {
  const { accountDetail, loadingAccount } = useAccountDetailContext();

  return !loadingAccount ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Typography variant="h6"> {accountDetail?.name} </Typography>
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <BadgeOutlined color="primary" />}
            title="Display Name"
            subtitle={accountDetail?.displayName}
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <DomainOutlined color="primary" />}
            title="Domain"
            subtitle={accountDetail?.domain}
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <EmailOutlined color="primary" />}
            title="Email"
            subtitle={accountDetail?.email}
          >
            {accountDetail?.email ? (
              <a
                href={`mailto:${accountDetail?.email}`}
                className="custom-link"
              >
                {accountDetail?.email}
              </a>
            ) : (
              "N/A"
            )}
          </InformationTile>
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <Phone color="primary" />}
            title="Contact Number"
            subtitle={accountDetail?.contactNumber}
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <CategoryOutlined color="primary" />}
            title="Type"
            subtitle={accountDetail?.type}
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Status"
          >
            <Status isActive={accountDetail?.isActive} />
          </InformationTile>
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default AccountBasicDetail;
